import { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import App from './App';
import config from './config';
import ToastContext from './contexts/toast-context';
import './styles/app.css';

const theme = createTheme({
  palette: {
    primary: {
      main: '#075985',
    },
  },
});

const toastValues = {
  dark: toast.dark,
  default: toast,
  error: toast.error,
  info: toast.info,
  success: toast.success,
  warning: toast.warning,
  handleError: (e) => {
    let errorMessage = '';
    if (e.response) {
      errorMessage = e.response?.data?.message ?? e.response?.data ?? 'Something went wrong';
    } else {
      errorMessage = e.message ?? 'Could not connect to server';
    }
    toast.error(errorMessage);
  },
};

ReactDOM.render(
  <StrictMode>
    <ToastContext.Provider value={toastValues}>
      <ToastContainer containerId="toast-container" />
      <BrowserRouter basename={config.basePath}>
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>
      </BrowserRouter>
    </ToastContext.Provider>
  </StrictMode>,
  document.getElementById('root')
);
